import { render, staticRenderFns } from "./GameTileForm.vue?vue&type=template&id=49c0a6e8&"
import script from "./GameTileForm.vue?vue&type=script&lang=js&"
export * from "./GameTileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports